import React from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import closeIcon from '../../assets/icons/close.svg'
import Can from '../../components/Can'

const Wrapper = styled.div`
  background: #fff;
  font-family: 'Open Sans', sans-serif;
  border-radius: ${pxToRem('7px')};
`

const CabinetProduct = styled.li`
  list-style: none;
  margin-top: ${pxToRem(7)};
  padding: ${pxToRem(9)} ${pxToRem(10)};
  border: 1px solid #dadfe2;
  color: #858585;
  display: flex;
  align-items: center;
`

const RemoveCabinetProduct = styled.button`
  background: url(${closeIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  width: 14px;
  height: 14px;
  border: none;
`

const ProductWrapper = styled.div`
  flex-direction: column;
  width: 90%;
`
const ProductName = styled.div`
  flex: 1;
  order: 0;
  font-size: ${pxToRem(14)};
`
const ProductProvider = styled.div`
  flex: 1;
  order: 1;
  font-size: ${pxToRem(11)};
`
const ProductSupervisor = styled.div`
  flex: 1;
  order: 1;
  font-size: ${pxToRem(11)};
  margin-top: ${pxToRem(5)};
  color: ${color.secondary};
`

const Product = props => {
  const {
    productTitle,
    productSupervisoriesCode,
    productProvider,
    buttonAction,
    removeButtonFunctionality = '',
    ...rest
  } = props

  return (
    <Wrapper {...rest}>
      <CabinetProduct>
        <ProductWrapper>
          <ProductName>{productTitle}</ProductName>

          {productProvider && <ProductProvider>{productProvider}</ProductProvider>}
          {productSupervisoriesCode && <ProductSupervisor>{productSupervisoriesCode}</ProductSupervisor>}
        </ProductWrapper>
        <Can functionality={removeButtonFunctionality}>
          <RemoveCabinetProduct onClick={buttonAction} />
        </Can>
      </CabinetProduct>
    </Wrapper>
  )
}

export default Product



// WEBPACK FOOTER //
// ./src/components/Cabinet/Product.js